// Calls to our own API. Errors come back as { error, code, requestId } and are thrown as ApiError,
// so screens can show the message and the reference.
import type { ApiErrorBody } from '@shared/api';

export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly requestId: string | undefined;

  constructor(status: number, code: string, message: string, requestId?: string) {
    super(message);
    this.status = status;
    this.code = code;
    this.requestId = requestId;
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const res = await fetch(`/api${path}`, {
    ...init,
    // A file upload (FormData) sets its own content type.
    headers: init.body instanceof FormData ? init.headers : { 'content-type': 'application/json', ...init.headers },
    credentials: 'same-origin',
  });
  // An error from outside our API (a proxy, a dropped connection) may have no body, or a different one.
  const body = (await res.json().catch(() => null)) as Partial<ApiErrorBody> | null;
  if (!res.ok) {
    throw new ApiError(res.status, body?.code ?? 'unknown', body?.error ?? 'Something went wrong.', body?.requestId);
  }
  return body as T;
}
